import type { UserCourse } from '@teachur/http-client';

type CourseNote = NonNullable<UserCourse['notes']>[number];

export const sortCourseNotesByNewest = (notes: CourseNote[]) => {
  return [...notes].sort((a, b) => b.id - a.id);
};
